export const TITLEBAR_ICONS_REPLACEMENTS =
  [
    { original: 'icon-lion_DarkBG', replacement: 'icon-lion_whiteBG'}
  ];
